var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "DownloadContentButtons" },
    [
      _vm.showDownloadContentButton
        ? _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.download } },
            [_c("v-icon", [_vm._v(_vm._s(_vm.mdiDownload))])],
            1
          )
        : _vm._e(),
      _vm.showPrintContentButton
        ? _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.print } },
            [_c("v-icon", [_vm._v(_vm._s(_vm.mdiPrinter))])],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }